import { useEffect, useReducer } from "react";
import { useApi } from "@/lib/api";
import { getLang } from "@/i18n";

const cache = new Map<string, string>();
const queue = new Set<string>();
const listeners = new Set<() => void>();
const retries = new Map<string, number>();
let timer: ReturnType<typeof setTimeout> | undefined;

function request(api: any, text: string) {
  if (cache.has(text) || queue.has(text)) return;
  queue.add(text);
  clearTimeout(timer);
  timer = setTimeout(async () => {
    const batch = [...queue];
    queue.clear();
    try {
      const { data } = await api.post("/i18n/titles", { titles: batch });
      batch.forEach((x) => (data.titles[x] ? cache.set(x, data.titles[x]) : !data.failed?.includes(x) && cache.set(x, x)));
      (data.failed || []).forEach((x: string) => {
        const n = (retries.get(x) || 0) + 1;
        retries.set(x, n);
        if (n <= 2) setTimeout(() => request(api, x), 8000 * n);
        else cache.set(x, x);
      });
    } catch {
      /* leave uncached so a later render retries */
    }
    listeners.forEach((l) => l());
  }, 60);
}

export function useTitle(text: string) {
  const api = useApi();
  const [, rerender] = useReducer((x: number) => x + 1, 0);
  const active = getLang() !== "en" && !!text;
  useEffect(() => {
    if (!active) return;
    listeners.add(rerender);
    request(api, text);
    return () => { listeners.delete(rerender); };
  }, [api, text, active]);
  return active ? cache.get(text) || text : text;
}

export const titleOf = (text: string) => cache.get(text) || "";

export const Tt = ({ text }: { text: string }) => <>{useTitle(text)}</>;
